import CatalogOverviewImg from "../images/phoenix-katalog-uebersicht.jpg";
import CatalogChoiceImg from "../images/phoenix-katalog.jpg";
import Model, { URL_OVERVIEW } from "../model";
import Choice from "./catalog.choice.m";
import Form from "./catalog.form.m";
import m from "mithril";
export default {
    oninit({ state }) {
        state.auth = null;
        state.customer = null;
    },
    view({ state }) {
        var _a, _b;
        const { webtexte: wt } = Model;
        return (m("article", { class: "abo-catalog mv2" },
            m("div", { class: "row row--2er mb3" },
                m("div", { class: "catalog-img" },
                    m("a", { href: URL_OVERVIEW, title: "\u00DCbersicht der Phoenix Reisen Kataloge aufrufen" },
                        m("img", { src: CatalogOverviewImg, alt: "" }))),
                m("div", null,
                    m("h3", { class: "pt0-ns" }, (_a = wt === null || wt === void 0 ? void 0 : wt["katalogverwaltung__angebot__ueberschrift"]) !== null && _a !== void 0 ? _a : "Unser Angebot"),
                    m("div", null, (wt === null || wt === void 0 ? void 0 : wt["katalogverwaltung__angebot__text"]) ? (m.trust(wt === null || wt === void 0 ? void 0 : wt["katalogverwaltung__angebot__text"])) : (m("p", null, "Bl\u00E4ttern Sie durch unsere mit viel Erfahrung und Herzblut zusammengestellten Kataloge. Wir w\u00FCnschen Ihnen viel Freude beim Kennenlernen unserer Schiffe und interessanten Routen sowie weiterer Destinationen mit gro\u00DFem Hotelangebot."))),
                    m("p", { class: "tr" },
                        m("a", { class: "btn btn--link", href: URL_OVERVIEW, title: "\u00DCbersicht der Phoenix Reisen Kataloge aufrufen" },
                            "zur ",
                            m("span", { class: "desktop-only" }, "Katalog-"),
                            "\u00DCbersicht",
                            " ",
                            m("i", { class: "fas fa-arrow-right ml2" }))))),
            m("div", { class: "row row--2er mt3" },
                m("div", { class: "catalog-form" },
                    m("h3", { class: "pt0" }, (_b = wt === null || wt === void 0 ? void 0 : wt["katalogverwaltung__abonnements__ueberschrift"]) !== null && _b !== void 0 ? _b : "Ihre Abonnements"),
                    !state.customer ? (m(Form, { parent: state })) : (m(Choice, { parent: state }))),
                m("div", { class: "catalog-img desktop-only" },
                    m("img", { src: CatalogChoiceImg, alt: "" })))));
    },
};
